<template>
  <div class="header-wrapper animate fadeIn">
    <div class="profile-page">
      <div class="container">

        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
            <h2 class="header-title">แก้ไขข้อมูลส่วนตัว</h2>
            <form class="form form--box border" @submit.prevent="submit()" novalidate>
              <h3 class="form__title">ข้อมูลส่วนตัว</h3>

              <div class="form__item">
                <label class="form__label" for="email">อีเมล</label>
                <input class="form__input" type="text" name="v" id="email" v-model="info.email" required :class="{ 'form__input--error': $v.isError('email') }" />
                <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล</div>
                <div class="alert alert--error" v-show="$v.$errors.email.invalid">กรุณากรอกอีเมลให้ถูกต้อง</div>
              </div>

              <div class="form__item">
                <label class="form__label" for="firstName">ชื่อจริง</label>
                <input class="form__input" type="text" id="firstName" v-model="info.firstName" :class="{ 'form__input--error': $v.isError('firstName') }" />
                <div class="alert alert--error" v-show="$v.$errors.firstName.empty">กรุณากรอกชื่อของคุณ</div>
              </div>

              <div class="form__item">
                <label class="form__label" for="lastName">นามสกุล</label>
                <input class="form__input" type="text" id="lastName" v-model="info.lastName" :class="{ 'form__input--error': $v.isError('lastName') }" />
                <div class="alert alert--error" v-show="$v.$errors.lastName.empty">กรุณากรอกนามสกุล</div>
              </div>

              <div class="form__item">
                <label class="form__label" for="telNo">เบอร์โทรศัพท์</label>
                <input class="form__input" type="text" id="telNo" placeholder="0899999999" v-model="info.telNo" :class="{ 'form__input--error': $v.isError('telNo') }" />
                <div class="alert alert--error" v-show="$v.$errors.telNo.empty">กรุณาระบุเบอร์โทรศัพท์ที่ติดต่อได้</div>
                <div class="alert alert--error" v-show="!$v.$errors.telNo.empty && $v.$errors.telNo.invalid">กรุณากรอกเบอร์โทรให้ถูกต้อง</div>
              </div>

              <div class="text-center mt-15 mb-15" v-if="!passwordVisible">
                <button class="btn btn--center btn--white btn--full" @click.prevent="showPassword()">กดเพื่อเปลี่ยนรหัสผ่าน</button>
              </div>
              <div class="form__item" v-if="passwordVisible">
                <label class="form__label" for="password1">รหัสผ่าน</label>
                <input class="form__input" type="password" id="password1" v-model="info.password1" :class="{ 'form__input--error': $v.isError('password1') }" />
                <div class="alert alert--error" v-show="$v.$errors.password1.empty">กรุณากรอกรหัสผ่าน</div>
                <div class="alert alert--error" v-show="$v.$errors.password1.minLength">รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร</div>
                <div class="alert alert--error" v-show="$v.$errors.password1.tooEasy">กรุณาใช้รหัสผ่านที่เดายากกว่านี้</div>
              </div>
              <div class="form__item" v-if="passwordVisible">
                <label class="form__label" for="password2">ยืนยันรหัสผ่าน</label>
                <input class="form__input" type="password" id="password2" v-model="info.password2" :class="{ 'form__input--error': $v.isError('password2') }" />
                <div class="alert alert--error" v-show="$v.$errors.password2.empty">กรุณากรอกรหัสผ่าน</div>
                <div class="alert alert--error" v-show="!$v.$errors.password2.empty && $v.$errors.password2.unmatched">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
              </div>


              <address-form class="mt-30" ref="addressForm" :showButton="false" :back="false" :withBorder="false" :withPadding="false"></address-form>

              <button class="btn btn--purple btn--full mb-15" :disabled="submitting" @click.prevent="submit()">บันทึก</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressForm from './AddressForm.vue'

export default {
  components: {AddressForm},
  name: 'ProfilePage',
  data () {
    return {
      submitting: false,
      passwordVisible: false,
      info: {
        email: '',
        firstName: '',
        lastName: '',
        telNo: '',
        password1: '',
        password2: ''
      },
      $v: null
    }
  },
  created () {
    this.$store.dispatch('initUser').then(() => {
      Object.assign(this.info, this.$store.state.user)
      if (this.info.email && this.info.email.match(/tel.(\d+)@tcfe.or.th/g)) {
        this.info.email = ''
      }
    })

    this.$v = this.$validator.init(this.info, {
      email: { checkEmpty: true, checkEmail: true },
      firstName: { checkEmpty: true },
      lastName: { checkEmpty: true },
      telNo: { checkEmpty: true, checkPhone: true },
      password1: {
        checkEmpty: true,
        minLength: 6,
        checkPassword: true,
        required: () => this.info.password1 && this.info.password1.trim().length > 0
      },
      password2: {
        checkEmpty: true,
        checkMatch: 'password1',
        required: () => this.info.password1 && this.info.password1.trim().length > 0
      }
    })
  },
  methods: {
    showPassword () {
      this.passwordVisible = true
    },
    submit () {
      // cleansing e-mail
      this.info.email = this.$utils.cleanEmailInvisibleChars(this.info.email)

      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return
      }

      if (this.$refs.addressForm.validate()) {
        this.$refs.addressForm.submit()
      } else {
        return
      }

      if (this.submitting) {
        return
      }
      this.submitting = true
      this.$modal.show({
        title: 'กรุณารอสักครู่',
        text: 'กำลังอัปเดต​...',
        okButton: false
      })

      let newUser = Object.assign({}, this.$store.state.user, this.info)
      newUser.password1 = null
      newUser.password2 = null
      const address = this.$store.state.checkoutInfo
      const payload = {
        email: this.info.email,
        firstName: this.info.firstName,
        lastName: this.info.lastName,
        telNo: this.info.telNo,
        address: {
          address: address.address,
          province: address.province,
          postcode: address.postalCode
        },
        shippingContact: {
          firstName: this.info.firstName,
          lastName: this.info.lastName,
          telNo: this.info.telNo
        }
      }

      if (this.info.password1 && this.info.password1.trim().length > 0) {
        payload.password = this.info.password1
      }

      this.$http.post('members/profile', payload)
        .then(resp => {
          this.submitting = false
          this.$store.dispatch('setUser', newUser)
          this.$modal.hide()
          this.passwordVisible = false
          this.info.password1 = null
          this.info.password2 = null
          this.$store.state.toast.showToast('อัปเดตข้อมูลของคุณแล้ว', { timeLife: 1200 })
        })
        .catch(err => {
          console.log(err)
          this.submitting = false
          if (err.body.message && err.body.message.match(/validation.*e-mail.*exist/i)) {
            this.$modal.show({
              title: 'ผิดพลาด',
              text: 'อีเมลนี้มีผู้ใช้งานแล้ว'
            })
            this.$v.$errors.email.invalid = true
            this.$forceUpdate()
            this.$utils.scrollToFirstErrors()
            return
          }
          this.$utils.showCommonError()
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProfilePage.vue?d6ab4d38